import { Component, Input } from '@angular/core';
import { IUser } from '@shared/interfaces/user';
import { countries } from '@shared/helpers/countries';

@Component({
    selector: 'app-user-item',
    templateUrl: './user-item.component.html',
    styleUrls: ['./user-item.component.scss'],
    standalone: false
})
export class UserItemComponent {
    countries = countries;
    @Input() item: IUser;
    @Input() active: boolean;

    get imageCode(): string {
        const option = this.countries
            ? this.countries.find(e => e.code.toLowerCase() === this.item?.userData?.country?.toLowerCase())
            : null;
        return option?.code;
    }
}
